//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class StimulusControllers
{
	public static body: string = `body`;
	public static scrapersCreate: string = `scrapers--create`;
	public static scrapersDetail: string = `scrapers--detail`;
	public static scrapersDetailActions: string = `scrapers--detail-actions`;
	public static scrapersDetailWebPage: string = `scrapers--detail-web-page`;
	public static scrapersDetailWebPageOverview: string = `scrapers--detail-web-page-overview`;
	public static scrapersDetailWebPageDisabledWarning: string = `scrapers--detail-web-page-disabled-warning`;
	public static scrapersDetailWebPageScrapedResults: string = `scrapers--detail-web-page-scraped-results`;
	public static scrapersScrapedResults: string = `scrapers--scraped-results`;
	public static scrapersScrapedResultsWebPages: string = `scrapers--scraped-results-web-pages`;
	public static watchdogDetail: string = `watchdogs--detail`;
	public static watchdogDetailOverview: string = `watchdogs--detail-overview`;
	public static onboarding: string = `onboarding`;
}
